import facebook from "~/assets/icons8-facebook-24.svg"

export function FacebookIcon() {
  return <img src={facebook} style={{ height: "22px" }} />
}
